<template>
  <h4 class="text-subtitle-1 font-weight-medium" style="white-space: wrap;">
    <slot />
  </h4>
</template>

<style lang="scss" scoped>
.text-subtitle-1 {
  color: #000;
}
</style>
